import React, { FC, ReactNode } from "react";
import MinorNavbar from "../../navbar/MinorNavbar";
import MinorFooter from "../../footer/MinorFooter";
import RsvpFooter from "../../footer/RsvpFooter";
import RsvpNavbar from "../../navbar/RsvpNavbar";

interface Props {
  children: ReactNode;
}

const RsvpLayout: FC<Props> = ({ children }) => {
  return (
    <div>
      <RsvpNavbar />
      <div className="page-container">{children}</div>
      <RsvpFooter />
    </div>
  );
};

export default RsvpLayout;
